// extracted by mini-css-extract-plugin
export default {"color-grey-2":"#C2C2C2","colorGrey2":"#C2C2C2","color-black":"#000000","colorBlack":"#000000","container":"xB8QC","text":"KfJgr","button":"nuCrP","disabled":"adm9g"};